import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  style: {"height":"460px"}
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 3 }
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { class: "ion-text-center" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  style: {"user-select":"text"}
}
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["src", "onClick"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { key: 5 }
const _hoisted_27 = {
  key: 0,
  style: {"user-select":"text"}
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { key: 6 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["src"]
const _hoisted_32 = ["href"]
const _hoisted_33 = { slot: "content" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "ion-text-center" }
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = ["src", "onClick"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { slot: "content" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { style: {"padding-left":"12px"} }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { slot: "content" }
const _hoisted_54 = { style: {"color":"var(--ion-color-dark)"} }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 2 }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { slot: "content" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 7 }
const _hoisted_62 = { key: 8 }
const _hoisted_63 = { style: {"padding":"10px 20px"} }
const _hoisted_64 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ParentConsentSignatureModal = _resolveComponent("ParentConsentSignatureModal")!
  const _component_event_card = _resolveComponent("event-card")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_slides = _resolveComponent("slides")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_teacher_response_questions = _resolveComponent("teacher-response-questions")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_school_student_modal = _resolveComponent("school-student-modal")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideHeader)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, {
              class: "ion-no-padding",
              fixed: ""
            }, {
              default: _withCtx(() => [
                (_ctx.event && (_ctx.user.isSecondaryStudent || !_ctx.user.teacher))
                  ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_buttons, { slot: "start" }, {
                          default: _withCtx(() => [
                            (_ctx.isModal)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  slot: "icon-only",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_back_button, {
                                  key: 1,
                                  "default-href": "/home"
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_title, { class: "ion-no-padding" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, [
                                  (_ctx.event.status == 'TBC')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, "[Tentative] "))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("b", null, _toDisplayString(_ctx.event.name), 1)
                                ]),
                                (_ctx.event.anchorEventId == 'lms-scholarship')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                                      _cache[22] || (_cache[22] = _createTextVNode("Deadline: ")),
                                      _createElementVNode("i", null, _toDisplayString(_ctx.event.formattedDateTime), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                      _createElementVNode("i", null, [
                                        _createTextVNode(_toDisplayString(_ctx.event.formattedDateTime) + " ", 1),
                                        (_ctx.event.mode)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "[" + _toDisplayString(_ctx.event.mode == 'Online' ? 'Online' : `at ${_ctx.event.venue || 'Campus'}`) + "]", 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        ((_ctx.user.id || _ctx.user.phone) && _ctx.isAllowApply())
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              class: "no-text-transform",
                              style: {"margin-right":"2px"},
                              slot: "end",
                              color: "success",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.promptUpdateEventResponse(_ctx.event, 'Yes')), ["stop"])),
                              disabled: _ctx.isUserApplied(_ctx.event.userResponse)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.isUserApplied(_ctx.event.userResponse) ? 'Applied' : 'Apply'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              slot: "end",
                              color: "primary",
                              class: "no-text-transform",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openLoginModal()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode("Login to apply")
                                  ])),
                                  _: 1,
                                  __: [23]
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_buttons, { slot: "start" }, {
                          default: _withCtx(() => [
                            (_ctx.isModal)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  slot: "icon-only",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal()))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_back_button, {
                                  key: 1,
                                  "default-href": "/home"
                                }))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_title, { style: {"padding-left":"0"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                (_ctx.event && _ctx.event.name)
                                  ? (_openBlock(), _createElementBlock("h2", _hoisted_5, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.event.name), 1),
                                      _createElementVNode("small", null, " (" + _toDisplayString(_ctx.event.date) + ")", 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("h2", _hoisted_6, [
                                      _createElementVNode("b", null, _toDisplayString(_ctx.selectedService.name), 1)
                                    ]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.serviceId == 'bluebird-seed' && !_ctx.hideApplyBtn)
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              class: "no-text-transform",
                              style: {"margin-right":"2px"},
                              slot: "end",
                              color: "success",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.applyForBluebirdSeed())),
                              disabled: _ctx.hasAppliedForBluebirdSeed()
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.hasAppliedForBluebirdSeed() ? 'Applied' : 'Apply'), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        (_ctx.serviceId == 'bluebird')
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 1,
                              class: "no-text-transform",
                              style: {"margin-right":"2px"},
                              slot: "end",
                              color: "success",
                              href: "https://bluebird.fdmt.hk",
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode("Apply")
                                  ])),
                                  _: 1,
                                  __: [24]
                                })
                              ]),
                              _: 1
                            }))
                          : (_ctx.isAllowApply() && (_ctx.isSecondaryStudentView || _ctx.user.isSecondaryStudent || !_ctx.user.teacher) && _ctx.serviceSessions.length > 0 && !_ctx.isClientView)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 2,
                                class: "no-text-transform",
                                style: {"margin-right":"2px"},
                                slot: "end",
                                color: "success",
                                disabled: _ctx.serviceSessions.some(ev => _ctx.isUserApplied(ev.userResponse)),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.promptApplyServiceSessions()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.serviceSessions.some(ev => _ctx.isUserApplied(ev.userResponse)) ? 'Applied' : 'Apply'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          style: {"padding-top":"0"},
          fixed: ""
        }, {
          default: _withCtx(() => [
            (_ctx.event?.needParentConsent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ParentConsentSignatureModal, {
                    target: "shooting",
                    targetEvent: _ctx.event,
                    hideHeader: true,
                    onSubmitSignature: _ctx.handleParentConsentSignature
                  }, null, 8, ["targetEvent", "onSubmitSignature"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.appliedEvent() && _ctx.isUserApplied(_ctx.appliedEvent().userResponse))
              ? (_openBlock(), _createBlock(_component_ion_card, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_event_card, {
                      class: "ion-no-margin",
                      ev: _ctx.appliedEvent(),
                      user: _ctx.user,
                      noStrip: true,
                      hideEventName: true,
                      disableCardClick: true
                    }, null, 8, ["ev", "user"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isOutstandingParticipantView)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.selectedService?.embeddedYTLink)
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 0,
                        class: "responsive-embed",
                        style: {"width":"100%","height":"380px"},
                        src: _ctx.selectedService?.embeddedYTLink,
                        frameborder: "0",
                        allowfullscreen: ""
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_item, {
                      class: "ion-margin-top",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createElementVNode("p", null, "Past shooting moments", -1)
                          ])),
                          _: 1,
                          __: [25]
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.selectedService?.shootingPhotoLinks && _ctx.selectedService?.shootingPhotoLinks.length > 0)
                      ? (_openBlock(), _createBlock(_component_slides, {
                          key: 0,
                          imageLinks: _ctx.selectedService?.shootingPhotoLinks
                        }, null, 8, ["imageLinks"]))
                      : (_openBlock(), _createBlock(_component_slides, {
                          key: 1,
                          imageLinks: [1,2,3,4,5,6,7].map(i => require(`@/assets/shooting/${i}.jpg`))
                        }, null, 8, ["imageLinks"]))
                  ])
                ]))
              : (_ctx.selectedService?.nature == 'Video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_ctx.event?.videoLink || _ctx.selectedService?.embeddedYTLink)
                      ? (_openBlock(), _createElementBlock("iframe", {
                          key: 0,
                          class: "responsive-embed",
                          style: {"width":"100%","height":"380px"},
                          src: _ctx.event?.videoLink || _ctx.selectedService?.embeddedYTLink,
                          frameborder: "0",
                          allowfullscreen: ""
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ion_item, {
                        class: "ion-margin-top",
                        color: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                              _createElementVNode("p", null, "Past shooting moments", -1)
                            ])),
                            _: 1,
                            __: [26]
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.selectedService?.shootingPhotoLinks && _ctx.selectedService?.shootingPhotoLinks.length > 0)
                        ? (_openBlock(), _createBlock(_component_slides, {
                            key: 0,
                            imageLinks: _ctx.selectedService?.shootingPhotoLinks
                          }, null, 8, ["imageLinks"]))
                        : (_openBlock(), _createBlock(_component_slides, {
                            key: 1,
                            imageLinks: [1,2,3,4,5,6,7].map(i => require(`@/assets/shooting/${i}.jpg`))
                          }, null, 8, ["imageLinks"]))
                    ]),
                    _createVNode(_component_ion_item, {
                      class: "ion-margin-top",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createElementVNode("p", null, "Certificates", -1)
                          ])),
                          _: 1,
                          __: [27]
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.getServicePhotosByType('Work Ambassador Certificate').length > 0)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getServicePhotosByType('Work Ambassador Certificate'), (p, idx) => {
                              return (_openBlock(), _createBlock(_component_ion_col, { key: idx }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    style: {"cursor":"pointer"},
                                    src: p.photoLink,
                                    onClick: ($event: any) => (_ctx.openImageModal(p.photoLink))
                                  }, null, 8, _hoisted_12)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"cursor":"pointer"},
                              src: require('@/assets/dummy_cert_1.jpg'),
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openImageModal(require('@/assets/dummy_cert_1.jpg'))))
                            }, null, 8, _hoisted_13)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              style: {"cursor":"pointer"},
                              src: require('@/assets/dummy_cert_2.jpg'),
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openImageModal(require('@/assets/dummy_cert_2.jpg'))))
                            }, null, 8, _hoisted_14)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : ((!_ctx.user.teacher || _ctx.isSecondaryStudentView) && !_ctx.isClientView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        (_ctx.selectedService?.embeddedVideoSlideLink)
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              src: _ctx.selectedService?.embeddedVideoSlideLink,
                              frameborder: "0",
                              width: "100%",
                              height: "445px",
                              allowfullscreen: "true",
                              mozallowfullscreen: "true",
                              webkitallowfullscreen: "true"
                            }, null, 8, _hoisted_17))
                          : (_ctx.event?.videoLink || _ctx.selectedService?.embeddedYTLink)
                            ? (_openBlock(), _createElementBlock("iframe", {
                                key: 1,
                                class: "responsive-embed",
                                style: {"width":"100%","height":"380px"},
                                src: _ctx.event?.videoLink || _ctx.selectedService?.embeddedYTLink,
                                frameborder: "0",
                                allowfullscreen: ""
                              }, null, 8, _hoisted_18))
                            : (_ctx.event?.posterLink || _ctx.selectedService?.posterLink)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 2,
                                  style: {"max-height":"500px","cursor":"pointer"},
                                  src: _ctx.getProxyImgLink(_ctx.event?.posterLink || _ctx.selectedService?.posterLink)
                                }, null, 8, _hoisted_19))
                              : _createCommentVNode("", true)
                      ]),
                      (_ctx.selectedService?.description)
                        ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_accordion, { value: "details" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_item, {
                                    style: {"--border-width":"0px !important"},
                                    slot: "header",
                                    color: "medium"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                                          _createElementVNode("p", null, "All details (including school circular)", -1)
                                        ])),
                                        _: 1,
                                        __: [28]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_card, {
                                    style: {"margin":"1.5px"},
                                    slot: "content"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          (_ctx.selectedService?.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _createElementVNode("div", {
                                                  style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                                  innerHTML: _ctx.getLinkifiedText(_ctx.selectedService?.description)
                                                }, null, 8, _hoisted_21),
                                                _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.selectedService?.nature == 'Workshop')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(_component_ion_item, {
                              class: "ion-margin-top",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createElementVNode("p", null, "Past Workshop moments", -1)
                                  ])),
                                  _: 1,
                                  __: [30]
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              class: "ion-margin-top",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                                    _createElementVNode("p", null, "Certificates", -1)
                                  ])),
                                  _: 1,
                                  __: [31]
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.getServicePhotosByType('Workshop Certificate').length > 0)
                              ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getServicePhotosByType('Workshop Certificate'), (p, idx) => {
                                      return (_openBlock(), _createBlock(_component_ion_col, { key: idx }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            style: {"cursor":"pointer"},
                                            src: p.photoLink,
                                            onClick: ($event: any) => (_ctx.openImageModal(p.photoLink))
                                          }, null, 8, _hoisted_23)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          style: {"cursor":"pointer"},
                                          src: require('@/assets/dummy_cert_1.jpg'),
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openImageModal(require('@/assets/dummy_cert_1.jpg'))))
                                        }, null, 8, _hoisted_24)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_col, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          style: {"cursor":"pointer"},
                                          src: require('@/assets/dummy_cert_2.jpg'),
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openImageModal(require('@/assets/dummy_cert_2.jpg'))))
                                        }, null, 8, _hoisted_25)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.isClientView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_ctx.selectedService?.description)
                          ? (_openBlock(), _createBlock(_component_ion_accordion_group, {
                              key: 0,
                              value: "details",
                              style: {"margin-top":"10px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_accordion, { value: "details" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_item, {
                                      style: {"--border-width":"0px !important"},
                                      slot: "header",
                                      color: "fdmtred"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                                            _createElementVNode("p", null, "Friendly reminders", -1)
                                          ])),
                                          _: 1,
                                          __: [32]
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_card, {
                                      style: {"margin":"1.5px"},
                                      slot: "content"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_card_content, null, {
                                          default: _withCtx(() => [
                                            (_ctx.selectedService?.description)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                  _createElementVNode("div", {
                                                    style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                                    innerHTML: _ctx.getLinkifiedText(_ctx.selectedService?.description)
                                                  }, null, 8, _hoisted_28),
                                                  _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.hideTeacherResponse)
                          ? (_openBlock(), _createBlock(_component_teacher_response_questions, {
                              key: 1,
                              serviceId: _ctx.serviceId,
                              group: "service",
                              prefilledOption: _ctx.prefilledOption,
                              hideSubmitButton: false,
                              serviceSessions: _ctx.serviceSessions || [_ctx.event],
                              event: _ctx.event,
                              isClientView: true
                            }, null, 8, ["serviceId", "prefilledOption", "serviceSessions", "event"]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_ctx.user.teacher)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (_ctx.isWorkEvent())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                (_ctx.selectedService?.embeddedVideoSlideLink)
                                  ? (_openBlock(), _createElementBlock("iframe", {
                                      key: 0,
                                      src: _ctx.selectedService?.embeddedVideoSlideLink,
                                      frameborder: "0",
                                      width: "100%",
                                      height: "445px",
                                      allowfullscreen: "true",
                                      mozallowfullscreen: "true",
                                      webkitallowfullscreen: "true"
                                    }, null, 8, _hoisted_31))
                                  : _createCommentVNode("", true),
                                (_ctx.relatedSubject || _ctx.relatedClient?.topic)
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 1,
                                      color: "light",
                                      lines: "full",
                                      button: "",
                                      detail: "",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openCareerProspects()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.relatedSubject) + " " + _toDisplayString(_ctx.relatedClient?.topic) + " careers (teachers’ optional self-learning) ", 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  style: _normalizeStyle({ 'opacity': _ctx.isCompletedServiceAction('Show a 3-min video during class') ? 0.5 : 1 })
                                }, [
                                  _createVNode(_component_ion_item, { color: "primary" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, [
                                            _cache[35] || (_cache[35] = _createTextVNode(" 1. Share the 3-min video (if any) in the above slide (")),
                                            _createElementVNode("i", null, [
                                              _cache[34] || (_cache[34] = _createTextVNode("accessible at ")),
                                              _createElementVNode("a", {
                                                target: "_blank",
                                                href: _ctx.selectedService?.slideLink,
                                                style: {"color":"#fff"}
                                              }, [
                                                _createElementVNode("u", null, _toDisplayString(_ctx.selectedService?.slideLink?.replace("https://", "")), 1)
                                              ], 8, _hoisted_32)
                                            ]),
                                            _cache[36] || (_cache[36] = _createTextVNode(") during your class for students' QR code enrollment. ")),
                                            _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                                            _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                            _cache[39] || (_cache[39] = _createTextVNode("Please update the status below afterwards to stop continual reminders. "))
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_button, {
                                        color: "light",
                                        class: "no-text-transform ion-no-margin",
                                        style: {"margin-left":"4px","height":"auto"},
                                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.circularAccordion.$el.value = _ctx.circularAccordion.$el.value ? '' : 'circular'))
                                      }, {
                                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                                          _createTextVNode("Click here"),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode("for"),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode("Circular/"),
                                          _createElementVNode("br", null, null, -1),
                                          _createTextVNode("Details")
                                        ])),
                                        _: 1,
                                        __: [40]
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_accordion_group, { ref: "circularAccordion" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_accordion, { value: "circular" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_33, [
                                            _createVNode(_component_ion_card, { style: {"margin":"1.5px"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_card_content, null, {
                                                  default: _withCtx(() => [
                                                    (_ctx.selectedService?.description)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                          _createElementVNode("div", {
                                                            class: "allowSelectOneClick",
                                                            style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                                            innerHTML: _ctx.getLinkifiedText(_ctx.selectedService?.description)
                                                          }, null, 8, _hoisted_35),
                                                          _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
                                                          _createVNode(_component_ion_button, {
                                                            expand: "block",
                                                            class: "no-text-transform",
                                                            size: "small",
                                                            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.copyText(_ctx.htmlToPlainText(_ctx.selectedService?.description), 'Details copied.')), ["stop"]))
                                                          }, {
                                                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                                                              _createTextVNode(" Copy ")
                                                            ])),
                                                            _: 1,
                                                            __: [41]
                                                          })
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 512)
                                ], 4),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getServiceRelatedClasses(), (cl) => {
                                  return _withDirectives((_openBlock(), _createBlock(_component_ion_item, {
                                    class: "ion-text-wrap",
                                    key: cl,
                                    color: _ctx.getServiceTeacherClassResponse(cl) == _ctx.OPTION_IDS.skip ? 'medium' : (_ctx.getServiceTeacherClassResponse(cl) ? 'success' : undefined)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_select, {
                                        justify: "start",
                                        "label-placement": "start",
                                        label: cl,
                                        placeholder: "Your status",
                                        interface: "popover",
                                        value: _ctx.getServiceTeacherClassResponse(cl),
                                        onIonChange: ($event: any) => (_ctx.completeServiceAction($event, cl)),
                                        style: {"min-height":"26px","padding-left":"16px"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicizeResponseOptions(), (opt) => {
                                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                                              key: opt.id,
                                              value: opt.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(opt?.title), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "value", "onIonChange"])
                                    ]),
                                    _: 2
                                  }, 1032, ["color"])), [
                                    [_vShow, new Date() < new Date(_ctx.event?.startTimeStr)]
                                  ])
                                }), 128)),
                                _createVNode(_component_ion_item, {
                                  class: "ion-margin-top",
                                  color: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                      default: _withCtx(() => _cache[43] || (_cache[43] = [
                                        _createElementVNode("p", null, "2. After students' QR enrollment, their names will appear below. Please verify their names & mobile then nominate them. You can revoke them later.", -1)
                                      ])),
                                      _: 1,
                                      __: [43]
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_card, { style: {"overflow-y":"scroll","height":"60vh","margin-inline":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_school_student_modal, {
                                      hideHeader: true,
                                      schoolId: _ctx.user.schoolId,
                                      maxYearDSE: _ctx.selectedService.targetForms.includes('F.4') ? _ctx.getF4YearDSE() : _ctx.getF5YearDSE(),
                                      nominatingEvent: _ctx.user.isAdmin ? (_ctx.event || _ctx.serviceSessions[0] || {}) : _ctx.event || _ctx.serviceSessions[0],
                                      service: _ctx.selectedService
                                    }, null, 8, ["schoolId", "maxYearDSE", "nominatingEvent", "service"])
                                  ]),
                                  _: 1
                                }),
                                (['Visit', 'Workshop'].includes(_ctx.selectedService.nature))
                                  ? (_openBlock(), _createBlock(_component_ion_item, {
                                      key: 2,
                                      class: "ion-margin-top",
                                      color: "primary",
                                      target: "_blank",
                                      href: `https://fdmt.hk/r/${_ctx.user.schoolId}`,
                                      detail: "",
                                      button: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                                            _createElementVNode("p", null, "3. Attendance report, photos & certificates", -1)
                                          ])),
                                          _: 1,
                                          __: [44]
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["href"]))
                                  : _createCommentVNode("", true),
                                ((_ctx.selectedService.eventPhotoLinks || []).length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _createVNode(_component_slides, {
                                        imageLinks: _ctx.selectedService.eventPhotoLinks
                                      }, null, 8, ["imageLinks"]),
                                      (_ctx.selectedService.eventAlbumLink)
                                        ? (_openBlock(), _createBlock(_component_ion_item, {
                                            key: 0,
                                            color: "light",
                                            detail: "",
                                            button: "",
                                            href: _ctx.selectedService.eventAlbumLink,
                                            target: "_blank"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                  _createElementVNode("p", null, "More photos", -1)
                                                ])),
                                                _: 1,
                                                __: [45]
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["href"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedService.pastStudentSharingVideoIds?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      _createVNode(_component_ion_item, {
                                        class: "ion-margin-top",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                            default: _withCtx(() => _cache[46] || (_cache[46] = [
                                              _createElementVNode("p", null, "Past Outstanding Students' Sharing", -1)
                                            ])),
                                            _: 1,
                                            __: [46]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_slides, {
                                        videoIds: _ctx.selectedService.pastStudentSharingVideoIds
                                      }, null, 8, ["videoIds"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_ctx.isSurvey)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  (!_ctx.hideTeacherResponse)
                                    ? (_openBlock(), _createBlock(_component_teacher_response_questions, {
                                        key: 0,
                                        serviceId: _ctx.serviceId,
                                        group: "survey",
                                        isSurvey: true
                                      }, null, 8, ["serviceId"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, [
                                    (_ctx.selectedService?.embeddedVideoSlideLink)
                                      ? (_openBlock(), _createElementBlock("iframe", {
                                          key: 0,
                                          src: _ctx.selectedService?.embeddedVideoSlideLink,
                                          frameborder: "0",
                                          width: "100%",
                                          height: "445px",
                                          allowfullscreen: "true",
                                          mozallowfullscreen: "true",
                                          webkitallowfullscreen: "true"
                                        }, null, 8, _hoisted_41))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          style: {"max-height":"500px","cursor":"pointer"},
                                          src: _ctx.getProxyImgLink(_ctx.event?.posterLink || _ctx.selectedService?.posterLink),
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openServiceSlideLink()))
                                        }, null, 8, _hoisted_42)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedService?.extraPosterLinks, (posterLink) => {
                                      return (_openBlock(), _createElementBlock("div", { key: posterLink }, [
                                        _createElementVNode("img", {
                                          style: {"max-height":"500px","cursor":"pointer"},
                                          src: _ctx.getProxyImgLink(posterLink),
                                          onClick: ($event: any) => (_ctx.openImageModal(_ctx.getProxyImgLink(posterLink)))
                                        }, null, 8, _hoisted_43)
                                      ]))
                                    }), 128))
                                  ]),
                                  (_ctx.selectedService?.id == 'mock-jupas')
                                    ? (_openBlock(), _createBlock(_component_ion_item, {
                                        key: 0,
                                        color: "success",
                                        button: "",
                                        detail: "",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.openMockJUPASToolModal()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[47] || (_cache[47] = [
                                              _createElementVNode("span", null, "Try out the tool", -1)
                                            ])),
                                            _: 1,
                                            __: [47]
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.selectedService?.description)
                                    ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_accordion, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_item, {
                                                style: {"--border-width":"0px !important"},
                                                slot: "header",
                                                color: "fdmtred"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => [
                                                      (_ctx.selectedService?.id == 'mock-jupas')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Invited schools just need to arrange"))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_45, "Details"))
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_button, {
                                                    size: "small",
                                                    onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.copyText(_ctx.htmlToPlainText(_ctx.selectedService?.description), 'Text copied.')), ["stop"])),
                                                    class: "no-text-transform"
                                                  }, {
                                                    default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                      _createTextVNode(" Copy ")
                                                    ])),
                                                    _: 1,
                                                    __: [48]
                                                  })
                                                ]),
                                                _: 1
                                              }),
                                              _createElementVNode("div", _hoisted_46, [
                                                _createVNode(_component_ion_card, { style: {"margin":"1.5px"} }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_card_content, null, {
                                                      default: _withCtx(() => [
                                                        (_ctx.selectedService?.description)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                              _createElementVNode("div", {
                                                                class: "allowSelectOneClick",
                                                                style: {"white-space":"pre-line","color":"var(--ion-color-dark)"},
                                                                innerHTML: _ctx.getLinkifiedText(_ctx.selectedService?.description)
                                                              }, null, 8, _hoisted_48)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.hideTeacherResponse && _ctx.serviceId != 'bluebird-seed')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                        _createVNode(_component_ion_item, { color: "primary" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                              default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                _createElementVNode("p", null, " 1. Please update the status for each class below afterwards to stop continual reminders ", -1)
                                              ])),
                                              _: 1,
                                              __: [49]
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        (_ctx.selectedService.isAllowProposeDates && !['Visit', 'Workshop'].includes(_ctx.selectedService.nature))
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getServiceRelatedClasses(), (cl) => {
                                                return (_openBlock(), _createBlock(_component_ion_item, {
                                                  class: "ion-text-wrap",
                                                  key: cl,
                                                  color: _ctx.getServiceTeacherClassResponse(cl) == _ctx.OPTION_IDS.skip ? 'medium' : (_ctx.getServiceTeacherClassResponse(cl) ? 'success' : undefined)
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_ctx.getServiceTeacherClassResponse(cl) == _ctx.OPTION_IDS.bookTime)
                                                      ? (_openBlock(), _createBlock(_component_ion_label, {
                                                          key: 0,
                                                          class: "ion-padding-start"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("p", null, [
                                                              _createTextVNode(_toDisplayString(cl) + " ", 1),
                                                              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.getServiceTeacherClassResponse(cl, 'preferredSessionDates')) + " " + _toDisplayString(_ctx.getServiceTeacherClassResponse(cl, 'preferredSessionTime')), 1)
                                                            ])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : (_openBlock(), _createBlock(_component_ion_select, {
                                                          key: 1,
                                                          justify: "start",
                                                          "label-placement": "start",
                                                          label: cl,
                                                          placeholder: "Your choice",
                                                          interface: "popover",
                                                          value: _ctx.getServiceTeacherClassResponse(cl),
                                                          onIonChange: ($event: any) => (_ctx.completeServiceAction($event, cl)),
                                                          style: {"min-height":"26px","padding-left":"16px"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proposeDateResponseOptions(), (opt) => {
                                                              return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                                key: opt.id,
                                                                value: opt.id
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(opt.title), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["value"]))
                                                            }), 128))
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["label", "value", "onIonChange"]))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["color"]))
                                              }), 128)),
                                              _createVNode(_component_ion_modal, {
                                                class: "form-modal stack-modal",
                                                "is-open": _ctx.bookTimeData.isModalOpened,
                                                "backdrop-dismiss": false,
                                                "show-backdrop": true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_header, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_toolbar, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_ion_buttons, { slot: "start" }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_button, {
                                                                slot: "icon-only",
                                                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.bookTimeData.isModalOpened = false))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          }),
                                                          _createVNode(_component_ion_title, {
                                                            class: "ion-text-left",
                                                            style: {"padding-left":"0"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_label, null, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("h2", null, [
                                                                    _createElementVNode("b", null, "Book a time for " + _toDisplayString(_ctx.bookTimeData.targetClass), 1)
                                                                  ])
                                                                ]),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_content, { class: "ion-padding" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_teacher_response_questions, {
                                                        serviceId: _ctx.serviceId,
                                                        group: "service",
                                                        serviceSessions: _ctx.serviceSessions || [_ctx.event],
                                                        event: _ctx.event,
                                                        targetClass: _ctx.bookTimeData.targetClass,
                                                        prefilledOptionId: _ctx.bookTimeData.prefilledOptionId
                                                      }, null, 8, ["serviceId", "serviceSessions", "event", "targetClass", "prefilledOptionId"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }, 8, ["is-open"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _createVNode(_component_teacher_response_questions, {
                                                serviceId: _ctx.serviceId,
                                                group: "service",
                                                prefilledOption: _ctx.prefilledOption,
                                                serviceSessions: _ctx.serviceSessions || [_ctx.event],
                                                event: _ctx.event
                                              }, null, 8, ["serviceId", "prefilledOption", "serviceSessions", "event"])
                                            ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])),
                          _cache[53] || (_cache[53] = _createElementVNode("hr", null, null, -1)),
                          (_ctx.schoolProposedSessions().length > 0)
                            ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 3 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        lines: "full",
                                        slot: "header",
                                        color: "light"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                                              _createElementVNode("p", null, "My school's session(s)", -1)
                                            ])),
                                            _: 1,
                                            __: [50]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_53, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolProposedSessions(), (ev) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            lines: "full",
                                            key: ev,
                                            button: "",
                                            detail: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, {
                                                class: "ion-text-wrap",
                                                style: {"line-height":"1"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, [
                                                    _createElementVNode("b", _hoisted_54, _toDisplayString(ev.name), 1),
                                                    _createTextVNode(" (" + _toDisplayString(ev.date) + ")", 1)
                                                  ]),
                                                  (ev.classes || ev.studentForms)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_55, _toDisplayString(ev.classes || ev.studentForms), 1))
                                                    : _createCommentVNode("", true),
                                                  (ev.inChargeTeacherNames)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_56, "In charge: " + _toDisplayString(ev.inChargeTeacherNames), 1))
                                                    : (_ctx.getMockJUPASDeadline(ev, 'inChargeTeacherNames'))
                                                      ? (_openBlock(), _createElementBlock("small", _hoisted_57, " In charge: " + _toDisplayString(_ctx.getMockJUPASDeadline(ev, 'inChargeTeacherNames')), 1))
                                                      : _createCommentVNode("", true),
                                                  _createElementVNode("p", null, [
                                                    (_ctx.getMockJUPASDeadline(ev))
                                                      ? (_openBlock(), _createElementBlock("small", _hoisted_58, "Deadline for students: " + _toDisplayString(_ctx.getMockJUPASDeadline(ev)), 1))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.recentResponses().length > 0)
                            ? (_openBlock(), _createBlock(_component_ion_accordion_group, { key: 4 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_accordion, { style: {"--min-height":"24px"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, {
                                        lines: "full",
                                        slot: "header",
                                        color: "light"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => _cache[51] || (_cache[51] = [
                                              _createElementVNode("p", null, "My previous responses/actions", -1)
                                            ])),
                                            _: 1,
                                            __: [51]
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_59, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentResponses().slice(0, 10), (resp, idx) => {
                                          return (_openBlock(), _createBlock(_component_ion_item, {
                                            key: idx,
                                            lines: "full"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", null, [
                                                    (resp.targetClass)
                                                      ? (_openBlock(), _createElementBlock("span", _hoisted_60, "[" + _toDisplayString(resp.targetClass) + "]", 1))
                                                      : _createCommentVNode("", true),
                                                    _createTextVNode(" " + _toDisplayString(resp.response) + " ", 1),
                                                    _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                                                    _createElementVNode("small", null, _toDisplayString(_ctx.formatDate(resp.updatedAt)), 1)
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
            (_ctx.serviceId == 'bluebird-seed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createVNode(_component_ion_button, {
                    class: "no-text-transform",
                    expand: "block",
                    href: "https://bluebird.fdmt.hk/regulations",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.documentOutline
                      }, null, 8, ["icon"]),
                      _cache[54] || (_cache[54] = _createTextVNode(" Bluebird Seed member regulations "))
                    ]),
                    _: 1,
                    __: [54]
                  }),
                  (_ctx.user.userConsentRecords?.find(r => r.target == 'bluebird-seed'))
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        lines: "none",
                        button: "",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.openBBSParentConsentModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            class: "ion-text-wrap",
                            style: {"padding-left":"28px"}
                          }, {
                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                              _createElementVNode("h3", null, [
                                _createElementVNode("b", null, "Parent Consent Obtained")
                              ], -1)
                            ])),
                            _: 1,
                            __: [55]
                          }),
                          _createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: _ctx.checkmarkCircle,
                            color: "success"
                          }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }))
                    : (_ctx.hasAppliedForBluebirdSeed())
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 1,
                          lines: "none",
                          color: "danger",
                          button: "",
                          detail: "",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openBBSParentConsentModal()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: "ion-text-wrap",
                              style: {"padding-left":"28px"}
                            }, {
                              default: _withCtx(() => _cache[56] || (_cache[56] = [
                                _createElementVNode("h3", null, [
                                  _createElementVNode("b", null, "Parent Consent Required!")
                                ], -1),
                                _createElementVNode("p", null, "To join Bluebird Seed, we need your parent's or guardian's consent.", -1)
                              ])),
                              _: 1,
                              __: [56]
                            }),
                            _createVNode(_component_ion_button, {
                              class: "no-text-transform",
                              slot: "end"
                            }, {
                              default: _withCtx(() => _cache[57] || (_cache[57] = [
                                _createTextVNode("Start")
                              ])),
                              _: 1,
                              __: [57]
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.serviceId == 'bluebird')
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _cache[59] || (_cache[59] = _createElementVNode("iframe", {
                    class: "responsive-embed",
                    style: {"width":"100%","height":"380px"},
                    src: "https://www.youtube.com/embed/Wv37M8o0X8E?si=zQH16jdzwr5CsxRw",
                    frameborder: "0",
                    allowfullscreen: ""
                  }, null, -1)),
                  _createVNode(_component_ion_button, {
                    class: "no-text-transform",
                    expand: "block",
                    href: "https://bluebird.fdmt.hk/regulations",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.documentOutline
                      }, null, 8, ["icon"]),
                      _cache[58] || (_cache[58] = _createTextVNode(" Bluebird regulations "))
                    ]),
                    _: 1,
                    __: [58]
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_modal, {
          class: "ack-modal",
          "is-open": _ctx.isAckModalOpened
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("p", null, [
                _cache[60] || (_cache[60] = _createTextVNode("The video slide link will be sent to your WhatsApp group (")),
                _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.user.waGroupLink
                }, _toDisplayString(_ctx.user.waGroupLink), 9, _hoisted_64),
                _cache[61] || (_cache[61] = _createTextVNode(") in minutes for your forwarding."))
              ])
            ]),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, {
                  slot: "end",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isAckModalOpened = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, { color: "primary" }, {
                      default: _withCtx(() => _cache[62] || (_cache[62] = [
                        _createTextVNode("OK")
                      ])),
                      _: 1,
                      __: [62]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    }),
    (_ctx.event && (_ctx.user.isAdmin || !_ctx.user.teacher))
      ? (_openBlock(), _createBlock(_component_ion_footer, { key: 1 }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_ion_toolbar, { class: "ion-text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, {
                  style: {"padding-top":"0"},
                  fixed: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "no-text-transform",
                      color: "success",
                      size: "small",
                      onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.promptUpdateEventResponse(_ctx.event, 'Confirmed')), ["stop"])),
                      disabled: _ctx.event.userResponse?.response == 'Confirmed'
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.event.userResponse?.response == "Confirmed" ? 'Confirmed 已確認出席' : 'Confirm 按此確認出席'), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_ion_icon, {
                          slot: "end",
                          icon: _ctx.checkmark
                        }, null, 8, ["icon"]), [
                          [_vShow, _ctx.event.userResponse?.response == 'Confirmed']
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      class: "no-text-transform",
                      color: "danger",
                      size: "small",
                      onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.promptUpdateEventResponse(_ctx.event, 'No')), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => _cache[63] || (_cache[63] = [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, "Withdraw 按此取消報名")
                            ], -1)
                          ])),
                          _: 1,
                          __: [63]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, (_ctx.user.isAdmin || _ctx.showActionBtns) && _ctx.isUserApplied(_ctx.event.userResponse)]
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}